import script from "./FisiologicaSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FisiologicaSection.vue?vue&type=script&setup=true&lang=ts"

import "./FisiologicaSection.vue?vue&type=style&index=0&id=988435a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-988435a2"]])

export default __exports__